var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{},[_c('v-row',[_c('v-col',[_c('input',{staticClass:"my_input",attrs:{"type":"file","id":"upload"},on:{"change":_vm.cargarPedidosExcel}}),_c('div',{ref:"result"})]),_c('v-col',[_c('v-data-table',{staticClass:"elevation-1",attrs:{"dense":"","headers":_vm.headers,"items":_vm.arrayErpPedidosGuatex,"item-key":"name"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }